import type { DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { ChatCompletions } from "../../../ChatCompletions";
import { setMessages } from "../../../ChatCompletions/redux/slice";
import { ClearButton } from "../../../Components/Buttons/ClearButton";
import styles from "./styles.module.css";

interface Props extends DialogProps {
  closeModal?: () => void;
}

export const ChatModal = ({ closeModal, ...props }: Props) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleClearChat = () => {
    dispatch(setMessages([]));
  };

  return (
    <ModalBasic
      title={t("chat_modal.title")}
      hasCloseButton
      closeModal={closeModal}
      onClose={closeModal}
      hasHeaderPaddingBottom
      className={styles["chat-modal"]}
      {...props}
    >
      <div className={styles["content-header"]}>
        <ClearButton
          typeBtn={"text_btn"}
          iconType={"broom"}
          onClick={handleClearChat}
          isDisabled={false}
          className={styles.clear}
        />
      </div>
      <ChatCompletions className={styles.chat} />
    </ModalBasic>
  );
};
